import { Controller } from "@hotwired/stimulus"
import WebViewer from "@pdftron/pdfjs-express"

const viewerStates = new WeakMap()

const DISABLED_ELEMENTS = [
  "printModal",
  "freeHandToolGroupButton",
  "selectToolButton",
  "textToolGroupButton",
  "shapeToolGroupButton",
  "signatureToolButton",
  "freeTextToolButton",
  "stickyToolButton",
  "miscToolGroupButton",
  "toolsButton",
  "searchButton",
  "menuButton",
  "leftPanelButton",
  "eraserToolButton",
  "viewControlsButton",
  "panToolButton",
  "contextMenuPopup",
]

// PDF.js Express viewer for job file show page.
export default class extends Controller {
  static targets = ["mount", "error"]

  static values = {
    handle: String,
    fp: Boolean,
    as: String,
  }

  connect() {
    this.connected = true
    this.initialize()
  }

  disconnect() {
    this.connected = false

    const state = viewerStates.get(this.mountTarget)
    if (!state || state.owner !== this) return

    if (state.instance) this.dispose(state)
  }

  initialize() {
    const existingState = viewerStates.get(this.mountTarget)
    if (existingState) {
      existingState.owner = this
      return
    }

    this.mountTarget.classList.remove("hidden")
    this.errorTarget.classList.add("hidden")

    const initialDoc = this.fpValue
      ? `https://cdn.filepicker.io/${this.handleValue}`
      : `${window.location.origin}${this.asValue}`

    const state = { owner: this, instance: null }
    viewerStates.set(this.mountTarget, state)

    state.promise = WebViewer(
      {
        path: "/pdftron/pdfjsexpress",
        css: "/pdftron/pdfjsexpress/ui/style.css",
        initialDoc,
        disabledElements: DISABLED_ELEMENTS,
      },
      this.mountTarget
    )

    state.promise.then((instance) => {
      state.instance = instance

      if (!state.owner.connected) {
        this.dispose(state)
        return
      }

      instance.setHeaderItems((header) => {
        const items = header.getItems().slice(2, -9)
        header.update(items)
      })
    }).catch((error) => {
      if (typeof Bugsnag !== "undefined") {
        Bugsnag.notify(error, (event) => {
          event.addMetadata("job_file_viewer", { source: "webviewer" })
        })
      }

      const owner = state.owner
      this.dispose(state)
      if (owner.connected) owner.showError()
    })
  }

  dispose(state) {
    state.instance?.UI?.dispose?.()
    this.mountTarget.replaceChildren()
    viewerStates.delete(this.mountTarget)
  }

  showError() {
    this.mountTarget.classList.add("hidden")
    this.errorTarget.classList.remove("hidden")
  }
}
